// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CardTick1Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CardTick1/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.833 12.5a3.332 3.332 0 0 0-3.333 3.333c0 .625.175 1.217.483 1.717a3.308 3.308 0 0 0 2.85 1.617c1.217 0 2.275-.65 2.85-1.617.309-.5.484-1.092.484-1.717a3.332 3.332 0 0 0-3.334-3.333Zm1.725 2.975-1.775 1.642a.636.636 0 0 1-.425.166.618.618 0 0 1-.441-.183l-.825-.825a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0l.4.4 1.333-1.234a.63.63 0 0 1 .884.034.63.63 0 0 1-.034.883ZM18.333 6.292v.375a.836.836 0 0 1-.833.833h-15a.836.836 0 0 1-.833-.833v-.384a3.446 3.446 0 0 1 3.45-3.45h9.758a3.46 3.46 0 0 1 3.458 3.459Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.667 9.583v4.134a3.446 3.446 0 0 0 3.45 3.45h5.216c.484 0 .9-.409.859-.892-.117-1.275.291-2.658 1.425-3.758a4.23 4.23 0 0 1 1.666-1.009 4.664 4.664 0 0 1 2.942.009.834.834 0 0 0 1.108-.784V9.575a.836.836 0 0 0-.833-.833h-15a.848.848 0 0 0-.833.841Zm5 4.792H5a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h1.667a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Z"
}));
export default CardTick1Icon;